// extracted by mini-css-extract-plugin
export default {"sticky-item":"WFRAi","sticky-container":"Q7LOa","hide-sticky":"F4C4E","fixed-sticky":"dLpIl"};